import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';
import {FirebaseAuthManager} from '../../data/manager/customer/firebase-auth/firebase-auth.manager';
import {LocationManager} from '../../data/manager/location/location.manager';
import { SessionStorageManager } from 'src/app/data/manager/session-storage/session-storage.manager';
import { RecaptchaManager } from 'src/app/data/manager/recaptcha/recaptcha.manager';
import { FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';
import { FirebaseManager } from 'src/app/data/manager/firebase/firebase.manager';

@Injectable({
  providedIn: 'root',
})
export class LoginFormVm {
  constructor(private customerManager: CustomerManager,
              private firebaseAuthManager: FirebaseAuthManager,
              private locationManager: LocationManager,
              private sessionStorageManager: SessionStorageManager,
              private recaptchaManager:RecaptchaManager,
              private firebaseManager: FirebaseManager,) { }

  login(data, recaptchaPayload?:object): Observable<any> {
    const dataInfo = {
      ...data,
      deliveryType: this.locationManager.getDeliveryType(),
      recaptchaPayload
    };
    return this.customerManager.login(dataInfo);
  }

  fetchFirebaseData(data): Observable<any> {
    return this.firebaseAuthManager.fetchFirebaseData(data);
  }

  getCustomerLogin(data, email?): Observable<any> {
   let newData;
    if(email !== undefined) {
      newData = {phone: data, email};
    }else{
      newData = typeof data === 'number' ? {phone: data} : {email: data};
    }
    return this.customerManager.getCustomerLogin(newData);
  }

  getCustomerOrigin(params): Observable<any> {
    return this.customerManager.getCustomerOrigin(params);
  }

  sendMessage(data, id): Observable<any> {
    const methodMessage = {
      customerRef: id,
      bySMS: true,
      byCall: false,
      byEmail: false,
      byWhatsApp: false,
    }

    return this.customerManager.sendMessage(methodMessage);
  }

  activeModalCretePassword() {
    this.customerManager.activeModalCreatePass = true;
  }

  removeItemSessionStorage(item){
    this.sessionStorageManager.removeItem( item );
  }

  setItemSessionStorage(key, value){
    this.sessionStorageManager.set(key, value);
  }

  actionRecaptcha(actionValue:string) {
    return this.recaptchaManager.actionRecaptcha(actionValue);
  }

  transformHashSHA256(data: string): Promise<string> {
    return this.recaptchaManager.transformHashSHA256(data); 
  }

  getCustomerIpAddress(){
    return this.recaptchaManager.getCustomerIpAddress();
   }

   getEvaluationRecaptcha(data:object) {
    return this.recaptchaManager.getEvaluationRecaptcha(data);
  }

  getConfigurationRecaptcha(){
    return this.recaptchaManager.getConfigurationRecaptcha();
  }
  
  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseManager.getRemoteConfig();
  }

}
